import { incomingStartDate } from "./timelineLanes.js";
import { isSentinelEndDate } from "../../features/leases/leaseTabConfig.js";

// Same fixed-day five-year convention as Monitor, not a decision-date anchor.
export const INCOMING_HORIZON_DAYS = 1825;
export const INCOMING_AXIS_TICKS = [1, 2, 3, 4, 5].map(year => ({
  days: year * 365, label: `${year}yr`,
}));
const DAY_MS = 86_400_000;

export function incomingRunway(lease, today) {
  const commencement = incomingStartDate(lease);
  const expiry = incomingStartDate({ startDate: lease.endDate });
  const boundary = incomingStartDate({ startDate: today });
  const fallback = { usable: false, commencement, expiry };
  if (!commencement || !expiry || !boundary
    || isSentinelEndDate(expiry.toISOString().slice(0, 10))) return fallback;
  // Past-expiry and zero/reversed terms cannot describe a forward commitment.
  if (expiry <= commencement || expiry <= boundary) return fallback;
  const startDays = (commencement - boundary) / DAY_MS;
  const endDays = (expiry - boundary) / DAY_MS;
  const pct = days => Math.max(0, Math.min(100, days / INCOMING_HORIZON_DAYS * 100));
  const startPct = pct(startDays);
  const endPct = pct(endDays);
  return {
    usable: true, commencement, expiry,
    future: startDays > 0,
    startPct, endPct, termWidth: Math.max(0, endPct - startPct),
    leadWidth: startDays > 0 ? startPct : 0,
    markerVisible: startDays <= INCOMING_HORIZON_DAYS,
    capped: endDays > INCOMING_HORIZON_DAYS,
  };
}
